// extracted by mini-css-extract-plugin
module.exports = {"container":"Container--container--1216O","fluid":"Container--fluid--LUBNe","placeholderAnim":"Container--placeholderAnim--2Xwoh"};